export interface Novel {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  description: string;
  content: string;
  author: string;
  coverImage: string;
  rating: number;
  views: number;
  tags: string[];
  publishDate: string;
  isHot: boolean;
  isRecommended: boolean;
  wordCount: string;
  status: '连载中' | '已完结';
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '禁忌之恋', slug: 'taboo-love', icon: 'ri-heart-2-line', description: '突破世俗束缚的禁忌情感故事，描绘人性深处最真实的爱与挣扎' },
  { name: '都市情感', slug: 'urban-romance', icon: 'ri-building-2-line', description: '繁华都市中的爱情故事，现代人的情感纠葛与人生选择' },
  { name: '豪门恩怨', slug: 'wealthy-drama', icon: 'ri-vip-diamond-line', description: '权贵世家的爱恨情仇，财富与权力交织下的情感博弈' },
  { name: '虐恋情深', slug: 'angst-romance', icon: 'ri-emotion-sad-line', description: '虐心虐身的深情虐恋，在痛苦中绽放的爱情之花' },
  { name: '甜宠言情', slug: 'sweet-romance', icon: 'ri-emotion-happy-line', description: '甜蜜治愈的恋爱故事，温暖人心的都市童话' },
  { name: '悬疑情感', slug: 'suspense-love', icon: 'ri-search-eye-line', description: '悬疑与爱情交织，谜团背后隐藏的深情真相' },
];

export const novels: Novel[] = [
  {
    id: 'novel-1',
    title: '嫂子的诱惑',
    slug: 'sister-in-law-temptation',
    category: '禁忌之恋',
    categorySlug: 'taboo-love',
    description: '当命运将两个人推向无法抗拒的深渊，道德的边界在情感面前变得模糊。这是一个关于禁忌、背叛与救赎的都市情感故事，深入探讨人性中最复杂的情感纠葛。',
    content: `<p>林晓雯从未想过，自己的人生会因为一个人而彻底改变。</p>
<p>那是一个闷热的夏夜，她第一次见到了大哥的新婚妻子——苏婉清。苏婉清穿着一袭白色连衣裙，长发如瀑布般倾泻在肩头，眉眼间带着一种令人无法移开视线的温柔与神秘。</p>
<p>"晓雯，这是你嫂子。"大哥林建国笑着介绍，眼中满是新婚的喜悦。</p>
<p>林晓雯礼貌地点头，却在四目相对的瞬间，心底涌起一种说不清道不明的悸动。那种感觉，像是一颗石子投入平静的湖面，激起层层涟漪。</p>
<p>故事从那一刻开始，悄然展开了一场命运的博弈。</p>
<p>苏婉清并非表面上看起来那么简单。她嫁入林家，背后隐藏着一个不为人知的秘密。而林晓雯作为家族企业的继承人，渐渐发现自己被卷入了一场精心策划的阴谋之中。</p>
<p>在这场禁忌的游戏里，每个人都戴着面具，每句话都暗藏深意。当真相一层层被揭开，林晓雯惊讶地发现，那个她以为最危险的人，恰恰是唯一真心待她的人。</p>
<p>禁忌之恋如同一簇火焰，明知不可触碰，却忍不住想要靠近。在道德与欲望的交锋中，两个人越陷越深，无法自拔。</p>
<p>这是一部关于禁忌之爱的都市情感力作。它不仅仅是一个爱情故事，更是一面映照人性的镜子——在爱情面前，我们究竟愿意付出多大的代价？</p>`,
    author: '墨染清尘',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20urban%20romance%20novel%20cover%20style%2C%20warm%20atmospheric%20lighting%2C%20elegant%20woman%20silhouette%20in%20a%20luxurious%20apartment%2C%20soft%20rose%20and%20amber%20tones%2C%20mysterious%20and%20sensual%20mood%2C%20literary%20fiction%20aesthetic%2C%20minimal%20composition%2C%20clean%20background%20with%20subtle%20texture&width=600&height=800&seq=sister-in-law-cover&orientation=portrait',
    rating: 4.8,
    views: 1285600,
    tags: ['禁忌之恋', '都市情感', '叔嫂关系', '虐心', 'HE'],
    publishDate: '2024-03-15',
    isHot: true,
    isRecommended: true,
    wordCount: '85万字',
    status: '连载中',
  },
  {
    id: 'novel-2',
    title: '暗夜蔷薇',
    slug: 'dark-night-rose',
    category: '都市情感',
    categorySlug: 'urban-romance',
    description: '她是这座城市最耀眼的蔷薇，却在暗夜中独自绽放。一段跨越阶层的爱情，两个世界的人，能否冲破世俗的藩篱？',
    content: `<p>蔷薇花在暗夜中绽放得最为艳丽。</p><p>沈蔷薇，这个名字在A市的金融圈无人不知。二十八岁的她已经是华尔街归来的金牌投资人，冷艳、果决、不近人情——这是外界给她的所有标签。</p><p>但没有人知道，在每个深夜，她都会独自站在落地窗前，看着这座不夜城的灯火阑珊，心中涌起无尽的孤独。</p><p>直到那个雨夜，她遇到了陆川——一个在街头卖唱的流浪歌手。</p><p>他的吉他声穿透了雨幕，也穿透了她层层包裹的心防。</p><p>两个来自完全不同世界的人，就这样相遇了。他们的故事，如同暗夜中绽放的蔷薇，美丽而危险。</p>`,
    author: '夜雨微凉',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20modern%20romance%20novel%20cover%2C%20woman%20in%20dark%20red%20dress%20standing%20by%20a%20rainy%20city%20window%20at%20night%2C%20warm%20ambient%20light%2C%20rose%20and%20charcoal%20tones%2C%20mysterious%20atmosphere%2C%20literary%20fiction%20aesthetic%2C%20minimal%20clean%20background&width=600&height=800&seq=dark-rose-cover&orientation=portrait',
    rating: 4.6,
    views: 956200,
    tags: ['都市情感', '阶层差异', '治愈', '成长'],
    publishDate: '2024-02-20',
    isHot: true,
    isRecommended: true,
    wordCount: '62万字',
    status: '已完结',
  },
  {
    id: 'novel-3',
    title: '豪门囚爱',
    slug: 'wealthy-captive-love',
    category: '豪门恩怨',
    categorySlug: 'wealthy-drama',
    description: '一纸契约，她成了他的囚徒。在这座金碧辉煌的牢笼中，爱情是最奢侈的奢望，也是最致命的毒药。',
    content: `<p>顾北辰是顾氏集团的太子爷，权势滔天，冷酷无情。</p><p>苏小念只是一个普通的大学生，因为父亲的债务，被迫签下了一纸契约——成为顾北辰为期三年的"契约妻子"。</p><p>在这座寸土寸金的豪门大宅里，每一块砖都透着冰冷的奢华。</p><p>顾北辰说："你只是一个工具，不要妄想得到我的感情。"</p><p>但在无数个日日夜夜的相处中，两个人之间的气氛渐渐发生了变化……</p><p>当苏小念发现契约背后隐藏的惊天秘密，她才明白，自己从一开始就被卷入了一场蓄谋已久的复仇计划。</p><p>爱与恨的边界如此模糊，她该如何抉择？</p>`,
    author: '云端漫步',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20wealthy%20family%20drama%20novel%20cover%2C%20luxurious%20mansion%20interior%20with%20chandelier%2C%20elegant%20couple%20silhouette%2C%20warm%20golden%20and%20burgundy%20tones%2C%20dramatic%20atmosphere%2C%20clean%20minimal%20composition%2C%20literary%20aesthetic&width=600&height=800&seq=wealthy-captive-cover&orientation=portrait',
    rating: 4.5,
    views: 1123400,
    tags: ['豪门恩怨', '契约婚姻', '先婚后爱', '虐恋'],
    publishDate: '2024-01-10',
    isHot: true,
    isRecommended: false,
    wordCount: '98万字',
    status: '连载中',
  },
  {
    id: 'novel-4',
    title: '第七年的痒',
    slug: 'seventh-year-itch',
    category: '都市情感',
    categorySlug: 'urban-romance',
    description: '婚姻的第七年，激情褪去后的平淡生活里，她意外发现了丈夫的秘密。当爱情变成习惯，是选择原谅还是转身离开？',
    content: `<p>周敏和丈夫结婚七年了。</p><p>七年，足够让一段轰轰烈烈的爱情沉淀为一潭死水。每天的对话只剩下"今天吃什么"和"孩子作业写完了吗"。</p><p>她以为这就是婚姻的常态——直到那天，她在丈夫的手机里发现了一条暧昧的短信。</p><p>发信人是他的女助理，年轻、漂亮、充满活力——就像七年前的她。</p><p>周敏开始了一场悄无声息的调查，却在这个过程中重新审视了自己的婚姻和人生。</p><p>七年之痒，是婚姻的终点，还是重生的起点？</p>`,
    author: '浅笑安然',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20marriage%20drama%20novel%20cover%2C%20woman%20looking%20out%20apartment%20window%20in%20soft%20afternoon%20light%2C%20melancholic%20warm%20tones%2C%20amber%20and%20cream%20color%20palette%2C%20clean%20minimal%20composition%2C%20literary%20fiction%20aesthetic&width=600&height=800&seq=seventh-year-cover&orientation=portrait',
    rating: 4.7,
    views: 876500,
    tags: ['婚姻情感', '都市生活', '女性成长', '现实向'],
    publishDate: '2024-04-05',
    isHot: false,
    isRecommended: true,
    wordCount: '45万字',
    status: '已完结',
  },
  {
    id: 'novel-5',
    title: '总裁的秘密情人',
    slug: 'ceo-secret-lover',
    category: '豪门恩怨',
    categorySlug: 'wealthy-drama',
    description: '她是落魄千金，他是商界帝王。一场交易让她成为他的秘密情人，但谁先动了真情，谁就输了全部。',
    content: `<p>沈氏集团破产的消息在商界引起了轩然大波。</p><p>沈若曦一夜之间从千金大小姐变成了负债累累的落魄女。为了挽救家族企业，她不得不向曾经的商业对手——厉霆琛求助。</p><p>厉霆琛开出的条件是：做他一年的秘密情人。</p><p>沈若曦咬咬牙，签下了这份屈辱的合同。她告诉自己，这只是一场交易。</p><p>但爱情从来不讲道理。在日复一日的相处中，两颗心不知不觉越靠越近。</p><p>当一年的期限即将到来，他们都发现自己已经无法潇洒地转身离开。</p>`,
    author: '风月无边',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20CEO%20romance%20novel%20cover%2C%20businessman%20and%20elegant%20woman%20in%20skyscraper%20office%20setting%2C%20warm%20golden%20hour%20lighting%2C%20burgundy%20and%20charcoal%20tones%2C%20dramatic%20romantic%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=800&seq=ceo-secret-cover&orientation=portrait',
    rating: 4.4,
    views: 1432000,
    tags: ['豪门恩怨', '总裁文', '秘密情人', '虐甜'],
    publishDate: '2023-12-18',
    isHot: true,
    isRecommended: false,
    wordCount: '110万字',
    status: '已完结',
  },
  {
    id: 'novel-6',
    title: '倾世虐恋：总裁的替身新娘',
    slug: 'stand-in-bride',
    category: '虐恋情深',
    categorySlug: 'angst-romance',
    description: '她代替双胞胎姐姐嫁入豪门，却发现自己只是一个替身。当真相揭开的那一刻，这段建立在谎言上的婚姻该何去何从？',
    content: `<p>苏若雪和姐姐苏若冰长着同一张脸，却有着截然不同的命运。</p><p>姐姐是万众瞩目的明星，而她只是活在姐姐光环下的影子。</p><p>当姐姐在婚礼前夕逃婚，家族逼迫苏若雪代替姐姐嫁给了秦家的继承人——秦墨寒。</p><p>婚后的每一天都如履薄冰。秦墨寒冷酷无情的面具下，隐藏着对姐姐深深的爱恋。而苏若雪，只是一个替身。</p><p>但人心是肉长的。当秦墨寒渐渐发现了姐妹俩的不同，情感的天平开始倾斜……</p>`,
    author: '花落知多少',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20angst%20romance%20novel%20cover%2C%20wedding%20dress%20silhouette%20in%20dramatic%20lighting%2C%20mirror%20reflection%20of%20two%20identical%20faces%2C%20burgundy%20and%20rose%20tones%2C%20emotional%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=800&seq=stand-in-bride-cover&orientation=portrait',
    rating: 4.3,
    views: 763400,
    tags: ['虐恋情深', '替身文学', '先婚后爱', '追妻火葬场'],
    publishDate: '2024-05-22',
    isHot: false,
    isRecommended: false,
    wordCount: '72万字',
    status: '连载中',
  },
  {
    id: 'novel-7',
    title: '你是我的小确幸',
    slug: 'you-are-my-little-happiness',
    category: '甜宠言情',
    categorySlug: 'sweet-romance',
    description: '她是一名甜品师，他是米其林三星主厨。在美食的世界里，两个灵魂相遇、碰撞，烹制出最甜蜜的爱情盛宴。',
    content: `<p>唐甜甜人如其名，是一个甜到骨子里的女孩。</p><p>她开了一家小小的甜品店，每天都用最新鲜的食材制作精致的甜点，把幸福传递给每一个客人。</p><p>直到那天，隔壁搬来了一位新邻居——从法国归来的米其林三星主厨傅言琛。</p><p>两个对美食有着极致追求的人，从最初的口舌之争，到后来的心心相印。</p><p>他说："你做甜点的样子，比甜点本身还要甜。"</p><p>这是一部充满了美食与甜蜜的爱情小说，没有虐心，只有治愈。</p>`,
    author: '甜心小饼干',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sweet%20romance%20novel%20cover%2C%20charming%20pastry%20shop%20setting%20with%20desserts%2C%20warm%20soft%20lighting%2C%20cream%20and%20peach%20tones%2C%20happy%20cozy%20atmosphere%2C%20clean%20minimal%20composition%2C%20cute%20aesthetic&width=600&height=800&seq=little-happiness-cover&orientation=portrait',
    rating: 4.9,
    views: 1890500,
    tags: ['甜宠言情', '美食', '治愈', '轻松'],
    publishDate: '2024-06-01',
    isHot: true,
    isRecommended: true,
    wordCount: '38万字',
    status: '已完结',
  },
  {
    id: 'novel-8',
    title: '迷雾之恋',
    slug: 'misty-love',
    category: '悬疑情感',
    categorySlug: 'suspense-love',
    description: '她的未婚夫在婚礼前夕失踪，所有人都说他死了。但一封神秘来信告诉她——他还活着。这背后究竟隐藏着什么惊天的秘密？',
    content: `<p>还有七天就是婚礼了。</p><p>安琪精心准备了半年的一切，却在一夜之间化为泡影——她的未婚夫程子轩失踪了。</p><p>警方搜寻了三个月，最终宣布程子轩可能已经遇害。</p><p>但就在所有人都放弃希望的时候，安琪收到了一封没有邮戳的信。信上只有一句话："他还活着，不要相信任何人。"</p><p>她决定独自追寻真相，却在调查过程中发现了未婚夫不为人知的另一面——他根本不是那个她以为的普通工程师。</p><p>每一个接近她的人都可能是敌人，每一个线索都通向更深的迷雾。</p><p>在这场悬疑与爱情交织的游戏中，真相远比想象中更加残酷。</p>`,
    author: '雾里看花',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20romance%20novel%20cover%2C%20foggy%20city%20street%20at%20night%20with%20woman%20looking%20over%20shoulder%2C%20mysterious%20moody%20lighting%2C%20charcoal%20and%20cool%20gray%20tones%2C%20thriller%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=800&seq=misty-love-cover&orientation=portrait',
    rating: 4.6,
    views: 678900,
    tags: ['悬疑情感', '推理', '犯罪', '反转'],
    publishDate: '2024-04-18',
    isHot: false,
    isRecommended: true,
    wordCount: '55万字',
    status: '连载中',
  },
  {
    id: 'novel-9',
    title: '姐夫的温柔陷阱',
    slug: 'brother-in-law-trap',
    category: '禁忌之恋',
    categorySlug: 'taboo-love',
    description: '姐姐去世后，她搬进姐夫家帮忙照顾孩子。朝夕相处中，一种不该产生的情感悄然滋生。是爱情还是依赖？是救赎还是深渊？',
    content: `<p>姐姐走后的第三个月，苏晚晴搬进了姐夫顾霖泽的家。</p><p>小侄女才三岁，还不懂得死亡的真正含义，每天都问妈妈什么时候回来。看着那双纯真的眼睛，苏晚晴的心都要碎了。</p><p>顾霖泽是一个沉默寡言的男人。白天他是雷厉风行的企业高管，晚上他是温柔细心的父亲。他对苏晚晴彬彬有礼，保持着恰到好处的距离。</p><p>但在这座充满回忆的房子里，两个受伤的灵魂互相取暖，一种不该产生的情感悄然滋生。</p><p>他们都清楚地知道这道道德的红线，却都在不知不觉中，一步步越过了它。</p><p>当小侄女天真地问"姑姑，你会做我的新妈妈吗"，苏晚晴才惊觉——自己早已坠入了一个温柔的陷阱。</p>`,
    author: '墨染清尘',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20taboo%20romance%20novel%20cover%2C%20woman%20in%20a%20cozy%20home%20setting%20with%20soft%20window%20light%2C%20warm%20amber%20and%20cream%20tones%2C%20melancholic%20tender%20atmosphere%2C%20clean%20minimal%20composition%2C%20literary%20fiction%20aesthetic&width=600&height=800&seq=brother-in-law-cover&orientation=portrait',
    rating: 4.7,
    views: 1056200,
    tags: ['禁忌之恋', '姐夫', '家庭伦理', '温暖治愈'],
    publishDate: '2024-03-28',
    isHot: true,
    isRecommended: false,
    wordCount: '68万字',
    status: '连载中',
  },
  {
    id: 'novel-10',
    title: '逆光之吻',
    slug: 'kiss-against-light',
    category: '虐恋情深',
    categorySlug: 'angst-romance',
    description: '他是她年少时最美好的暗恋，也是她长大后最痛苦的劫难。多年后重逢，当年那个温柔的少年已变成了冷酷的复仇者。',
    content: `<p>十六岁那年，顾念笙是学校里最受欢迎的男生。他阳光、温柔、成绩优异，是所有女生心中的白马王子。</p><p>乔以安默默喜欢了他整整三年，却从未说出口。</p><p>十年后，乔以安成为了一名独立设计师，事业小有成就。在一次商业晚宴上，她再次遇到了顾念笙。</p><p>但他已经完全不是她记忆中的模样了。他变得冷酷、不近人情，目光中充满了她看不透的复杂情绪。</p><p>他说："乔以安，你欠我的，我会一点一点讨回来。"</p><p>她不明白自己究竟做错了什么。直到一桩尘封十年的往事被重新揭开——原来，十年前的一场意外，彻底改变了他们两个人的命运。</p>`,
    author: '夜雨微凉',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20angst%20romance%20novel%20cover%2C%20couple%20silhouette%20against%20warm%20sunset%20backlight%2C%20emotional%20reunion%20scene%2C%20rose%20and%20golden%20tones%2C%20dramatic%20romantic%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=800&seq=kiss-against-light-cover&orientation=portrait',
    rating: 4.5,
    views: 892100,
    tags: ['虐恋情深', '重逢', '暗恋', '复仇'],
    publishDate: '2024-02-14',
    isHot: false,
    isRecommended: false,
    wordCount: '76万字',
    status: '已完结',
  },
  {
    id: 'novel-11',
    title: '以我深情，许你白首',
    slug: 'deep-love-till-white-hair',
    category: '甜宠言情',
    categorySlug: 'sweet-romance',
    description: '他是冷酷的医学教授，她是活泼的实习医生。在这场师徒恋中，他用最严谨的方式给了她最浪漫的爱情。',
    content: `<p>顾清音是医学院最年轻的教授，以严厉闻名全校。</p><p>苏念安偏偏被分配到了他的科室实习。第一天，她就被他训哭了三次。</p><p>但慢慢地，她发现这个冷面教授其实有着一颗最温柔的心。他会在她值夜班时偷偷放一杯热可可在她的桌上，会在她犯错时用最严格的方式保护她不受医院处分。</p><p>当苏念安鼓起勇气向他表白时，他只是推了推眼镜，严肃地说："根据医学统计，师生恋成功率不足5%，你确定要做这个风险投资？"</p><p>她笑了："那就让我做那个5%。"</p>`,
    author: '甜心小饼干',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sweet%20medical%20romance%20novel%20cover%2C%20hospital%20setting%20with%20warm%20lighting%2C%20young%20doctor%20couple%2C%20cream%20and%20mint%20green%20tones%2C%20gentle%20romantic%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=800&seq=deep-love-cover&orientation=portrait',
    rating: 4.8,
    views: 1567800,
    tags: ['甜宠言情', '医学', '师生恋', '轻喜剧'],
    publishDate: '2024-05-10',
    isHot: true,
    isRecommended: true,
    wordCount: '42万字',
    status: '已完结',
  },
  {
    id: 'novel-12',
    title: '消失的爱人',
    slug: 'gone-lover',
    category: '悬疑情感',
    categorySlug: 'suspense-love',
    description: '结婚五周年的纪念日，她消失了。所有人都说她是离家出走，只有他知道——她绝不会不辞而别。一场寻找真相的旅程就此展开。',
    content: `<p>五周年结婚纪念日，陈默订了妻子最喜欢的法式餐厅。</p><p>但她没有出现。手机打不通，所有朋友都说没见过她，家里的一切都保持着她出门前的样子。</p><p>警方说成年人失踪48小时后才能立案。陈默等不了那么久。</p><p>他开始自己调查，却发现了妻子一个又一个的秘密：她有一个他不知道的保险箱，她的手机里有被删除的通话记录，她的公司账户有大笔资金流动的痕迹。</p><p>他以为他们是最恩爱的夫妻，却发现他对妻子的了解是如此有限。</p><p>当真相逐步浮出水面，陈默发现自己正面临一个残酷的选择——继续寻找，可能要接受一个他无法承受的真相。</p>`,
    author: '雾里看花',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20suspense%20novel%20cover%2C%20empty%20room%20with%20single%20light%20source%2C%20wedding%20photo%20on%20table%2C%20dark%20atmospheric%20tones%2C%20charcoal%20and%20moody%20lighting%2C%20thriller%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=800&seq=gone-lover-cover&orientation=portrait',
    rating: 4.6,
    views: 723400,
    tags: ['悬疑情感', '失踪', '婚姻', '反转'],
    publishDate: '2024-06-20',
    isHot: false,
    isRecommended: false,
    wordCount: '48万字',
    status: '已完结',
  },
];

export const rankings = {
  weekly: novels.slice().sort((a, b) => b.views - a.views).slice(0, 10),
  monthly: novels.slice().sort((a, b) => b.rating - a.rating).slice(0, 10),
  completed: novels.filter(n => n.status === '已完结').slice(0, 10),
};

export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  content: string;
  rating: number;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: '小雨点',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20Chinese%20girl%20avatar%20profile%20picture%2C%20warm%20soft%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20smile&width=100&height=100&seq=avatar-1&orientation=squarish',
    content: '《嫂子的诱惑》真的是我今年看过最好的都市情感小说！作者对人物心理的刻画太细腻了，每一个转折都让人意想不到。强烈推荐！',
    rating: 5,
    date: '2024-07-15',
  },
  {
    id: 't2',
    name: '墨香书客',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20avatar%20profile%20picture%2C%20warm%20soft%20lighting%2C%20clean%20minimal%20background%2C%20professional%20look&width=100&height=100&seq=avatar-2&orientation=squarish',
    content: '这个网站的推荐真的很用心，不是那种随便堆砌热榜的平台。每篇导读都写得很认真，能感受到编辑的诚意。',
    rating: 5,
    date: '2024-07-10',
  },
  {
    id: 't3',
    name: '风中百合',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20avatar%20profile%20picture%2C%20warm%20soft%20lighting%2C%20clean%20minimal%20background%2C%20gentle%20expression&width=100&height=100&seq=avatar-3&orientation=squarish',
    content: '情感解析板块做得特别好，很多我之前似懂非懂的情节，看了分析文章之后豁然开朗。对网文爱好者来说简直是宝藏网站。',
    rating: 4,
    date: '2024-07-08',
  },
  {
    id: 't4',
    name: '夜色温柔',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20avatar%20profile%20picture%2C%20warm%20soft%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20smile&width=100&height=100&seq=avatar-4&orientation=squarish',
    content: '从第一次发现这个网站就爱上了！分类很清晰，找书特别方便。而且推荐的质量普遍很高，基本没有踩过雷。',
    rating: 5,
    date: '2024-07-05',
  },
];

export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '「嫂子的诱惑」是一个什么样的平台？',
    answer: '「嫂子的诱惑」是一个专注于都市禁忌情感小说的内容推荐平台。我们汇聚热门网络小说，提供专业的小说导读、情感解析和推荐榜单，帮助言情小说爱好者快速发现优质作品。我们的编辑团队由资深网文爱好者和文学评论人组成，每一篇推荐都经过认真筛选和深度分析。',
  },
  {
    question: '网站上的小说推荐是如何筛选的？',
    answer: '我们的推荐机制基于多个维度：编辑团队的专业评审、读者评分与反馈、作品的文学价值与可读性、以及当下热度和话题度。我们不追求单纯的流量热榜，而是致力于发掘那些真正值得一读的优秀作品，尤其是那些在叙事结构和情感表达上有所创新的小说。',
  },
  {
    question: '如何订阅更新通知？',
    answer: '您可以通过网站底部的订阅表单输入您的邮箱地址，我们会在每周五发送最新的推荐书单和深度解析文章到您的邮箱。我们承诺不会发送垃圾邮件，您可以随时取消订阅。',
  },
  {
    question: '我可以投稿推荐自己喜欢的作品吗？',
    answer: '当然可以！我们非常欢迎读者投稿。您可以通过"关于我们"页面的联系表单提交您的推荐作品和推荐理由。如果您的推荐被采纳，我们会注明您的贡献并赠送精美书签一套。',
  },
  {
    question: '网站上的文章可以转载吗？',
    answer: '本站所有原创内容均受版权保护。如需转载，请通过联系方式与我们取得授权。未经授权擅自转载将追究法律责任。我们鼓励分享文章链接，但不允许未经许可的全文复制和发布。',
  },
];